export default {
  de: {
    profile: 'Profil',
    logout: 'Logout',
    settings: 'Einstellungen',
    light: 'Hell',
    dark: 'Dunkel',
  },
};
